import React from 'react';
import { renderIcon } from '../../../FlowchartView/utils/renderIcon';
import { CampaignItemIcon } from '../../../../Sidebar/icons';

/**
 * Breadcrumb - Navigation path for nested campaigns
 * Shows parent campaigns as clickable links with icons
 */
const Breadcrumb = ({ 
  path = [], 
  onSelectSprint,
  classPrefix = 'campaign-header',
}) => {
  if (!path || path.length === 0) return null;

  return (
    <div className={`${classPrefix}__breadcrumb`}>
      {path.map((parent) => (
        <span key={parent.id}>
          <button 
            className={`${classPrefix}__breadcrumb-item`}
            onClick={() => onSelectSprint?.(parent)}
            title={`Go to ${parent.name}`}
          >
            {parent.icon ? (
              <span className={`${classPrefix}__breadcrumb-icon`}>
                {renderIcon(parent.icon, { size: '11px', fallback: null })}
              </span>
            ) : (
              <span className={`${classPrefix}__breadcrumb-icon`}>
                <CampaignItemIcon size={11} />
              </span>
            )}
            <span className={`${classPrefix}__breadcrumb-name`}>{parent.name}</span>
          </button>
          <span className={`${classPrefix}__breadcrumb-separator`}>/</span>
        </span>
      ))}
    </div>
  );
};

export default Breadcrumb;
